// Proprietà e costanti di configurazione per la tabella macchine

export const tableColumns = [
  { name: 'row_num', title: '#', getCellValue: row => row.row_num, isNumber: true },
  // { name: 'id', title: 'ID', getCellValue: row => row.id, isNumber: true },
  { name: 'actions', title: 'Actions', getCellValue: row => row },
  { name: 'brand', title: 'Brand', getCellValue: row => row.brand },
  { name: 'model', title: 'Model', getCellValue: row => row.model },
  { name: 'engine_code', title: 'Engine Code', getCellValue: row => row.engine_code },
  { name: 'cylinders', title: 'Cylinders', getCellValue: row => row.cylinders, isNumber: true },
  { name: 'displacement', title: 'Displacement (cc)', getCellValue: row => row.displacement, isNumber: true },
  { name: 'power', title: 'Power (kW)', getCellValue: row => row.power, isNumber: true },
  { name: 'euro_code', title: 'Euro Code', getCellValue: row => row.euro_code },
  { name: 'petrol_ecu', title: 'Petrol ECU', getCellValue: row => row.petrol_ecu },
  // { name: 'description', title: 'Notes', getCellValue: row => row.description },
  { name: 'status', title: 'Status', getCellValue: row => row.status },
];

export const tableColumnWidths = [
  { columnName: 'row_num', width: 60 },
  { columnName: 'id', width: 80 },
  { columnName: 'actions', width: 200 },
  { columnName: 'brand', width: 150 },
  { columnName: 'model', width: 150 },
  // { columnName: 'description', width: 250 },
  { columnName: 'engine_code', width: 150 },
  { columnName: 'cylinders', width: 100 },
  { columnName: 'displacement', width: 100 },
  { columnName: 'power', width: 100 },
  { columnName: 'euro_code', width: 150 },
  { columnName: 'petrol_ecu', width: 200 },
  { columnName: 'status', width: 110 },
];

/**
 * @type {import('@devexpress/dx-react-grid-material-ui').ColumnExtension[]}
 */
export const tableColumnExtensions = [
  { columnName: 'row_num', align: 'right' },
  { columnName: 'id', align: 'right' },
  { columnName: 'cylinders', align: 'right' },
  { columnName: 'displacement', align: 'right' },
  { columnName: 'power', align: 'right' },
];

export const tableFilteringStateColumnExtensions = [
  { columnName: 'row_num', filteringEnabled: false },
  { columnName: 'actions', filteringEnabled: false },
];
